// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
const savingCollectionTypes = {
	/************************ GET SEARCH MEMBER SAVING DETAILS START ****************** */
	GET_SEARCH_MEMBER_SAVING_DETAILS_START: 'get_search_member_saving_details_start',
	GET_SEARCH_MEMBER_SAVING_DETAILS_SUCCESS: 'get_search_member_saving_details_success',
	GET_SEARCH_MEMBER_SAVING_DETAILS_FAILURE: 'get_search_member_saving_details_failure',
	GET_SEARCH_MEMBER_SAVING_DETAILS_RESPONSE_RESET:
		'get_search_member_saving_details_response_reset',
	GET_SEARCH_MEMBER_SAVING_DETAILS_RESPONSE_CHANGED:
		'get_search_member_saving_details_response_changed',
	/************************ GET SEARCH MEMBER SAVING DETAILS END ****************** */

	/************************ FETCH MEMBER SAVING DETAILS START ****************** */
	FETCH_MEMBER_SAVING_DETAILS_START: 'fetch_member_saving_details_start',
	FETCH_MEMBER_SAVING_DETAILS_SUCCESS: 'fetch_member_saving_details_success',
	FETCH_MEMBER_SAVING_DETAILS_FAILURE: 'fetch_member_saving_details_failure',
	FETCH_MEMBER_SAVING_DETAILS_RESPONSE_RESET: 'fetch_member_saving_details_response_reset',
	FETCH_MEMBER_SAVING_DETAILS_RESPONSE_CHANGED: 'fetch_member_saving_details_response_changed',
	/************************ FETCH MEMBER SAVING DETAILS END ****************** */

	/************************ GET PARTICULAR ACCOUNT INFO START ****************** */
	GET_PARTICULAR_ACCOUNT_INFO_START: 'get_particular_account_info_start',
	GET_PARTICLUAR_ACCOUNT_INFO_SUCCESS: 'get_particular_account_info_success',
	GET_PARTICULAR_ACCOUNT_INFO_FAILURE: 'get_particular_account_info_failure',
	GET_PARTICULAR_ACCOUNT_INFO_RESPONSE_RESET: 'get_particular_account_info_response_reset',
	GET_PARTICULAR_ACCOUNT_INFO_RESPONSE_CHANGED: 'get_particular_account_info_response_changed',
	/************************ GET PARTICULAR ACCOUNT INFO END ****************** */
	/************************ ADD SAVING MEMBER SAVING ACCOUNT START ****************** */
	ADD_SAVING_MEMBER_SAVING_ACCOUNT_START: 'add_saving_member_saving_account_start',
	ADD_SAVING_MEMBER_SAVING_ACCOUNT_SUCCESS: 'add_saving_member_saving_account_success',
	ADD_SAVING_MEMBER_SAVING_ACCOUNT_FAILURE: 'add_saving_member_saving_account_failure',
	ADD_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_RESET:
		'add_saving_member_saving_account_response_reset',
	ADD_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_CHANGED:
		'add_saving_member_saving_account_response_changed',
	/************************ ADD SAVING MEMBER SAVING ACCOUNT END ****************** */

	/************************ DELETE SAVING MEMBER SAVING ACCOUNT START ****************** */
	DELETE_SAVING_MEMBER_SAVING_ACCOUNT_START: 'delete_saving_member_saving_account_start',
	DELETE_SAVING_MEMBER_SAVING_ACCOUNT_SUCCESS: 'delete_saving_member_saving_account_success',
	DELETE_SAVING_MEMBER_SAVING_ACCOUNT_FAILURE: 'delete_saving_member_saving_account_failure',
	DELETE_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_RESET:
		'delete_saving_member_saving_account_response_reset',
	DELETE_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_CHANGED:
		'delete_saving_member_saving_account_response_changed',
	/************************ DELETE SAVING MEMBER SAVING ACCOUNT END ****************** */
};
export default savingCollectionTypes;
